import * as moment from 'moment/moment'
import * as CONST from './const'

const initState = {
  pickupTimesList: [],
  initialPickupTimesList: [],
}

export function pickupTimes(state = initState, action) {
  switch (action.type) {
    case CONST.GET_PICKUP_TIMES_BY_CITY_ID_SUCCESS:
      return {
        ...state,
        pickupTimesList: action.payload.pickupTimesList,
        initialPickupTimesList: action.payload.pickupTimesList,
      }

    case CONST.ADD_PICKUP_TIME:
      return {
        ...state,
        pickupTimesList: [
          ...state.pickupTimesList,
          transformNewPickup(action.payload),
        ],
      }

    case CONST.CANCEL_PICKUP_TIME:
      return {
        ...state,
        pickupTimesList: state.initialPickupTimesList,
      }

    case CONST.REMOVE_PICKUP_TIME:
      return {
        ...state,
        pickupTimesList: [
          ...state.pickupTimesList.slice(0, action.payload),
          ...state.pickupTimesList.slice(action.payload + 1),
        ],
      }

    case CONST.SAVE_PICKUP_TIMES_LIST_SUCCESS:
      return {
        ...state,
        pickupTimesList: action.payload.pickupTimesList,
        initialPickupTimesList: action.payload.pickupTimesList,
      }

    default:
      return state
  }
}

function transformNewPickup(newPickupTime) {
  return {
    day: CONST.DAYS_OF_THE_WEEK.find(item => item.value === newPickupTime.day)
      .label,
    timeStart: moment(newPickupTime.timeStart).format('HH:mm:ss'),
    timeStop: moment(newPickupTime.timeStop).format('HH:mm:ss'),
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/PickupTimes/reducer.js